import { render, staticRenderFns } from "./ContactsTableForLazyLoadingWithResize.vue?vue&type=template&id=03e938fe&scoped=true"
import script from "./ContactsTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"
export * from "./ContactsTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e938fe",
  null
  
)

export default component.exports